import { render } from "./CommonProgress.vue?vue&type=template&id=54b5a816&scoped=true"
const script = {}

import "./CommonProgress.vue?vue&type=style&index=0&id=54b5a816&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b5a816"]])

export default __exports__